export { RiskPage as default } from '@/components/pages/Ir/Manage/Risk'
